import Vue from 'vue'
import App from './App.vue'
import router from './router'
import api from './api';
import localization from './localization';
import settings from './settings';
import store from './store'
import VueLazyload from 'vue-lazyload';

Vue.config.productionTip = false

Vue.use(api)

Vue.use(localization)

Vue.use(settings)

Vue.use(store)

Vue.use(VueLazyload)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

